<p-table [value]="invoices">
    <ng-template pTemplate="header">
        <tr>
            <th>id</th>
            <th>number</th>
            <th>amount</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-invoice>
        <tr routerLink="/management/sales-invoice-detail/{{invoice.id}}">
            <td>{{invoice.id}}</td>
            <td>{{invoice.invoiceNumber}}</td>
            <td>{{invoice.totalNetAmount}}</td>
        </tr>
    </ng-template>
</p-table>